import { DatedSalesStatistic } from "../../../../models/Statistics";
import moment from "moment";
import { SalesSumDataSet, StoreSum } from "./types";
import { isOk } from "../../../../result";

export const dataSetFromResponse = (
  res: any,
  startDateTime?: Date,
  stopDateTime?: Date
): SalesSumDataSet => {
  if (isOk(res)) {
    return formatDataSet(res.value, startDateTime, stopDateTime);
  }
  return {} as SalesSumDataSet;
};

export const formatDataSet = (
  dataset: any,
  startDateTime?: Date,
  stopDateTime?: Date
): SalesSumDataSet => {
  let sales = getAccumulativeSalesPerDateTime(
    dataset as DatedSalesStatistic[],
    startDateTime,
    stopDateTime
  );

  return {
    sales: sales,
    uniqueUsers: getNumberOfUniqueUsers(dataset as DatedSalesStatistic[])
  } as SalesSumDataSet;
};

export const getAccumulativeSalesPerDateTime = (
  salesStatistics: any[],
  startDatetime?: Date,
  stopDateTime?: Date
): any[] => {
  const storeSums = salesStatistics
    .map(store => {
      const fireStoreData = store.hasOwnProperty("SumReceiptByDateTime");
      const dates = Object.keys(
        fireStoreData ? store.SumReceiptByDateTime : store.sumReceiptByDateTime
      );
      return Object.values(
        fireStoreData ? store.SumReceiptByDateTime : store.sumReceiptByDateTime
      ).map((sumReceipt: any, idx) => {
        const d = new Date(dates[idx]);
        return {
          time: moment({
            hours: d.getHours(),
            minutes: d.getMinutes(),
            seconds: d.getSeconds(),
            milliseconds: d.getMilliseconds()
          }).toDate(),
          sum: fireStoreData ? sumReceipt.Sum : sumReceipt.sum
        };
      });
    })
    .flat();

  storeSums.sort((a, b) => a.time.getTime() - b.time.getTime());

  if (!storeSums.length) {
    return [];
  }

  let sumUpToDatetime = storeSums.reduce((acc: any, curr: any, i) => {
    if (i === 0) {
      return [curr];
    }
    curr.sum += acc[i - 1].sum;
    return [...acc, curr];
  }, []);

  return extendStartAndEndDateDateTimes(
    sumUpToDatetime,
    startDatetime,
    stopDateTime
  );
};

const extendStartAndEndDateDateTimes = (
  storeSums: StoreSum[],
  startDateTime?: Date,
  stopDateTime?: Date
) => {
  if (!storeSums.length) {
    return storeSums;
  }

  const first = storeSums[0];
  if (startDateTime && moment(first.time).isAfter(moment(startDateTime))) {
    const firstDataPoint = {
      time: moment({
        hours: startDateTime.getHours(),
        minutes: startDateTime.getMinutes(),
        seconds: startDateTime.getSeconds()
      }).toDate(),
      sum: 0
    } as StoreSum;
    storeSums = [firstDataPoint, ...storeSums];
  }

  const last = storeSums[storeSums.length - 1];
  if (stopDateTime && moment(last.time).isBefore(moment(stopDateTime))) {
    const lastDatapoint = {
      time: moment({
        hours: stopDateTime.getHours(),
        minutes: stopDateTime.getMinutes(),
        seconds: stopDateTime.getSeconds()
      }).toDate(),
      sum: last.sum
    } as StoreSum;
    storeSums = [...storeSums, lastDatapoint];
  }
  return storeSums;
};

export const getNumberOfUniqueUsers = (statistics: DatedSalesStatistic[]) => {
  return statistics.reduce((prev, current) => {
    return prev + current.uniqueUsers;
  }, 0);
};
